import {Overlay, OverlayConfig, OverlayRef} from "@angular/cdk/overlay";
import {CdkPortal} from "@angular/cdk/portal";
import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Subscription} from "rxjs";
import {NotificationModel} from "../../models/components/notification.model";
import {NotificationService} from "../../services/components/notification.service";

@Component({
    selector: "pcg-ng-notification",
    template: require('./notification.component.html')
})
export class NotificationComponent implements OnInit, OnDestroy {

    @ViewChild(CdkPortal)
    private template: CdkPortal;

    private overlayRef: OverlayRef;

    private showSubscription: Subscription;
    private hideSubscription: Subscription;

    public notifications: Array<NotificationModel> = new Array<NotificationModel>();

    public constructor(
        private overlay: Overlay,
        private notificationService: NotificationService
    ) {
    }

    public ngOnInit(): void {
        const config: OverlayConfig = {
            positionStrategy: this.overlay.position()
                .global()
                .top()
        };

        this.overlayRef = this.overlay.create(config);

        this.showSubscription = this.notificationService.showNotificationObservable
            .subscribe(this.showNotification);
        this.hideSubscription = this.notificationService.hideNotificationObservable
            .subscribe(this.hideNotification);
    }

    public ngOnDestroy(): void {
        if (this.showSubscription) {
            this.showSubscription.unsubscribe();
            this.showSubscription = null;
        }
        if(this.overlayRef) {
            this.overlayRef.dispose();
        }
    }

    public handleHideClick(notification: NotificationModel): void {
        this.notificationService.hideNotification(notification);
    }

    private showNotification = (notification: NotificationModel) => {
        this.notifications.push(notification);
        if(!this.overlayRef.hasAttached()) {
            this.overlayRef.attach(this.template);
        }

        setTimeout(() => {
            this.hideNotification(notification);
        },3000);
    }

    private hideNotification = (notification: NotificationModel) => {
        const index = this.notifications.indexOf(notification);

        if(index > -1) {
            this.notifications.splice(index, 1);
        }

        if(!this.notifications.length) {
            this.cleanUp();
        }
    }

    private cleanUp(): void {
        if (this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
        }
    }
}
